// Use this file to set global defaults for axios requests

import axios from 'axios';

axios.defaults.headers.common['X-Api-Key'] = '20f14594b5c141768fb6da5b82b8d146';